import { IGlobalStore } from "../store/global/GlobalStore";
import { Quote } from "../types/quote";
import { Chain } from "@rainbow-me/rainbowkit";

import {
  NETWORK_TO_BEBOP_CONTRACT_ADDRESS_MAP,
  NETWORK_TO_TOKEN_ADDRESS_MAP,
  Token,
} from "../store/global/TokenEnum";
import { API_BASE_URL, API_VERSION } from "../config/env";
import { NETWORK_TO_PRICE_ENDPOINT_MAP } from "./bootstrapWagmi";
import { TokenMetadata } from "../store/global/getTokenMetadata";

export const isQuantityLargerThanBalance = (store: IGlobalStore) => {
  return store.takerTokens.some(token => {
    const balanceForToken = store.balances.find(balance => balance.symbol === token.token)?.balance
      .value;
    const inputtedQuantity = token.amount.value;
    return balanceForToken?.lt(inputtedQuantity);
  });
};

export const getParamTypes = () => {
  return {
    EIP712Domain: [
      { name: "name", type: "string" },
      { name: "version", type: "string" },
      { name: "chainId", type: "uint256" },
      { name: "verifyingContract", type: "address" },
    ],
    Aggregate: [
      { name: "expiry", type: "uint256" },
      { name: "taker_address", type: "address" },
      { name: "maker_addresses", type: "address[]" },
      { name: "maker_nonces", type: "uint256[]" },
      { name: "taker_tokens", type: "address[][]" },
      { name: "maker_tokens", type: "address[][]" },
      { name: "taker_amounts", type: "uint256[][]" },
      { name: "maker_amounts", type: "uint256[][]" },
      { name: "receiver", type: "address" },
      { name: "commands", type: "bytes" },
    ],
  } as const;
};
export const getParamDomain = (chain: Chain) => {
  return {
    name: "BebopSettlement",
    version: "1",
    chainId: Number(chain.id),
    verifyingContract: NETWORK_TO_BEBOP_CONTRACT_ADDRESS_MAP[chain.id],
  } as const;
};
export const getTokenAddressBySymbol = (
  tokens: TokenMetadata | undefined,
  chain: Chain,
  symbol: Token
): `0x${string}` => {
  if (tokens) {
    return (
      tokens[symbol]?.chainInfo[0].contractAddress ?? NETWORK_TO_TOKEN_ADDRESS_MAP[chain.id][symbol]
    );
  }
  return NETWORK_TO_TOKEN_ADDRESS_MAP[chain.id][symbol];
};

export const getSendOrderEndpoint = (quote: Quote, chain: Chain) => {
  return `${API_BASE_URL}/${NETWORK_TO_PRICE_ENDPOINT_MAP[chain.name]}/${API_VERSION}/order`;
};
export const getSignatureData = (signedData: string) => {
  const sig = "0x" + signedData.substring(2);
  return {
    signature: sig,
  };
};
